import React from "react";

const Restricted = ({
  userType,
  roleId,
  allowedRoleId = [],
  allowedUserType,
  children,
}) => {
  const isAllowed =
    userType == 1
      ? allowedRoleId.includes(Number(roleId))
      : userType == allowedUserType
      ? true
      : false;
  return isAllowed ? <>{children}</> : null;
};

export default Restricted;
